import React from "react";
import { Box, makeStyles } from "@material-ui/core";

import type { TabProps } from "./Tab";
import Tab from "./Tab";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
  },
}));

export interface TabsProps {
  tabs: TabProps[];
  selectedIndex: number;
}

const Tabs = ({ tabs, selectedIndex }: TabsProps): JSX.Element => {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = React.useState<number>(selectedIndex);

  React.useEffect(() => {
    setSelectedTab(selectedIndex);
  }, [selectedIndex]);

  return (
    <Box className={classes.root} data-testid="tabs">
      {tabs.map((tab: TabProps, index: number) => (
        <Tab
          key={tab.name}
          {...tab}
          handleOnClick={() => {
            setSelectedTab(index);
            tab.handleOnClick();
          }}
          expanded={selectedTab === index || tab.expanded}
        />
      ))}
    </Box>
  );
};

export default Tabs;
